import { GIFT_STEP } from 'modules/gift/redux/constants'
import { createSelector } from 'reselect'
import getStepGiftSelect from 'modules/gift/redux/selectors/get-step'

const isAddAGiftCardStepGiftSelect = createSelector(
  getStepGiftSelect,
  step => step === GIFT_STEP.ADD_A_GIFT_CARD
)

export default isAddAGiftCardStepGiftSelect
